import * as tslib_1 from "tslib";
import _ from 'lodash';
import { GenericErrorResponseCode, } from '@tradingblock/types';
import { DateFormats, dateStringOrUndefined, GetTransferInstructionsDocumentMetadataUrl, GetTransferInstructionsDocumentsIdUrl, GetTransferInstructionsDocumentUrl, UploadCashieringDocumentUrl, } from '..';
import dayjs from 'dayjs';
const RequestHeaders = {
    headers: { Accept: 'application/json' },
};
export function SecurityQuestion(api) {
    return {
        fetch: () => {
            return api.authenticated().get(`User/GetSecurityChallenge`, {}, RequestHeaders);
        },
        verify: (data) => {
            return api.authenticated().post(`User/VerifySecurityChallenge`, data, RequestHeaders);
        },
    };
}
const transformTransfer = (transferLike) => {
    if (!transferLike)
        return transferLike;
    return Object.assign({}, transferLike, { achRelationshipId: transferLike.achRelationship });
};
export function Transfers(api) {
    return {
        all: (accountId, data) => {
            return api
                .authenticated()
                .get(`Cashiering/${accountId}/Transfers`, data || {}, RequestHeaders)
                .then(res => (Object.assign({}, res, { payload: res.payload ? res.payload.map(transformTransfer) : [] })));
        },
        get: (accountId, transferId) => {
            return api
                .authenticated()
                .get(`Cashiering/${accountId}/Transfers/${transferId}`, {}, RequestHeaders)
                .then(res => (Object.assign({}, res, { payload: transformTransfer(res.payload) })));
        },
        achDeposit: (accountId, data) => {
            return api.authenticated().post(`Cashiering/${accountId}/Transfers/Achs/Deposit`, data, RequestHeaders);
        },
        achWithdrawal: (accountId, data) => {
            return api.authenticated().post(`Cashiering/${accountId}/Transfers/Achs/Withdrawal`, data, RequestHeaders);
        },
        wireWithdrawal: (accountId, data) => {
            return api.authenticated().post(`Cashiering/${accountId}/Transfers/Wires/Withdrawal`, data, RequestHeaders);
        },
        checkWithdrawal: (accountId, data) => {
            return api.authenticated().post(`Cashiering/${accountId}/Transfers/Checks/Withdrawal`, data, RequestHeaders);
        },
        update: (accountId, transferId, payload) => {
            return api.authenticated().put(`Cashiering/${accountId}/Transfers/${transferId}/Update`, payload, RequestHeaders);
        },
        approve: {
            rep: (accountId, transferId, payload) => {
                return api
                    .authenticated()
                    .post(`Cashiering/${accountId}/Transfers/${transferId}/ApproveCreateRep`, payload || {}, RequestHeaders);
            },
            firm: (accountId, transferId, payload) => {
                return api
                    .authenticated()
                    .post(`Cashiering/${accountId}/Transfers/${transferId}/ApproveCreateFirm`, payload || {}, RequestHeaders);
            },
        },
        reject: (accountId, transferId, note) => {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/Transfers/${transferId}/RejectCreate`, { note }, RequestHeaders);
        },
        cancel: (accountId, transferId, comment) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/Transfers/${transferId}/Cancel`, { comment: comment || 'Cancelled by User' }, RequestHeaders);
        },
    };
}
export function ACH(api) {
    return {
        all: (accountId) => {
            return api.authenticated().get(`Cashiering/${accountId}/AchRelationships`, {}, RequestHeaders);
        },
        get: (accountId, achId) => {
            return api.authenticated().get(`Cashiering/${accountId}/AchRelationships/${achId}`, {}, RequestHeaders);
        },
        fetchPlaidLinkToken: (accountId, redirectUri) => {
            return api.authenticated().get(`Cashiering/${accountId}/AchRelationships/PlaidLinkToken`, {
                redirectUri: redirectUri,
            }, RequestHeaders);
        },
        create: (accountId, data) => {
            return api.authenticated().post(`Cashiering/${accountId}/AchRelationships`, data, RequestHeaders);
        },
        approve: (accountId, achId, request) => {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/AchRelationships/${achId}/Approve`, request, RequestHeaders);
        },
        approveCreate: (accountId, achId, note, adminNote, mapToRelationshipId) => {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/AchRelationships/${achId}/ApproveCreate`, { note, adminNote, mapToRelationshipId }, RequestHeaders);
        },
        rejectCreate: (accountId, achId, note) => {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/AchRelationships/${achId}/RejectCreate`, { note }, RequestHeaders);
        },
        reIssue: (accountId, achId) => {
            return api.authenticated().post(`Cashiering/${accountId}/AchRelationships/${achId}/ReIssue`, {}, RequestHeaders);
        },
        update: (accountId, achId, payload) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/AchRelationships/${achId}/Update`, payload, RequestHeaders);
        },
        cancel: (accountId, achId, comment) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/AchRelationships/${achId}/Cancel`, { comment: comment || 'Cancelled by User' }, RequestHeaders);
        },
    };
}
export function TransferInstructions(api) {
    return {
        all: (accountId) => {
            return api.authenticated().get(`Cashiering/${accountId}/TransferInstructions/Wires`, {}, RequestHeaders);
        },
        get: (accountId, instructionId) => {
            return api
                .authenticated()
                .get(`Cashiering/${accountId}/TransferInstructions/Wires/${instructionId}`, {}, RequestHeaders);
        },
        details: (instructionId) => {
            return api
                .authenticated()
                .get(`Cashiering/Search/TransferInstructions/Wires/${instructionId}/Details`, {}, RequestHeaders);
        },
        create: (accountId, data) => {
            return api.authenticated().post(`Cashiering/${accountId}/TransferInstructions/Wires`, data, RequestHeaders);
        },
        update: (accountId, instructionId, payload) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/TransferInstructions/Wires/${instructionId}/Update`, payload, RequestHeaders);
        },
        delete: (accountId, instructionId, comment) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/TransferInstructions/Wires/${instructionId}/Cancel`, { comment }, RequestHeaders);
        },
        approveCreate: (accountId, instructionId, payload) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/TransferInstructions/Wires/${instructionId}/ApproveCreate`, payload, RequestHeaders);
        },
        rejectCreate: (accountId, instructionId, payload) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/TransferInstructions/Wires/${instructionId}/RejectCreate`, payload, RequestHeaders);
        },
        cancel: (accountId, instructionId, payload) => {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/TransferInstructions/Wires/${instructionId}/Cancel`, payload, RequestHeaders);
        },
    };
}
export function cashieringSearch(api) {
    return {
        search: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const startDate = _.isNil(request.startDate) ? undefined : dateStringOrUndefined(request.startDate, 'YYYY-MM-DD');
            const endDate = _.isNil(request.endDate) ? undefined : dateStringOrUndefined(request.endDate, 'YYYY-MM-DD');
            const searchRequest = Object.assign({}, request, { endDate,
                startDate });
            const result = yield api
                .authenticated()
                .get(`Cashiering/Search`, searchRequest, RequestHeaders);
            return result;
        }),
    };
}
export function cashieringDetails(api) {
    return {
        relationshipDetails: (id) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { responseCode, payload } = yield api
                .authenticated()
                .get(`Cashiering/Search/AchRelationships/${id}/Details`, {}, RequestHeaders);
            const data = Object.assign({}, payload, { id });
            return { responseCode, payload: data };
        }),
        transferDetails: (id) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { responseCode, payload } = yield api
                .authenticated()
                .get(`Cashiering/Search/Transfers/${id}/Details`, {}, RequestHeaders);
            const data = Object.assign({}, payload, { id });
            return { responseCode, payload: data };
        }),
    };
}
export function cashieringDocuments(api) {
    return {
        upload: (file, accountId, recipientBankId, documentType, description) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const TakenOn = dayjs(file.lastModified)
                .utc()
                .format(DateFormats.DateTimeApiFormat);
            const data = new FormData();
            data.append('metaData', JSON.stringify({ DocumentName: documentType, ImageName: file.name, TakenOn, Description: description }));
            data.append('file', file);
            return api.authenticated().post(UploadCashieringDocumentUrl(accountId, recipientBankId), data);
        }),
        getId: (accountId, instructionId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { responseCode, payload } = yield api
                .authenticated()
                .get(GetTransferInstructionsDocumentsIdUrl(accountId, instructionId), {}, RequestHeaders);
            return { responseCode, payload };
        }),
        getDoc: (accountId, recipientBankId, id) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = GetTransferInstructionsDocumentUrl(accountId, recipientBankId, id);
            try {
                const result = yield api.authenticated().getBinary(url, { accountId, recipientBankId, id });
                if (result.status === 200) {
                    const base64 = Buffer.from(result.data, 'binary').toString('base64');
                    const imageBase64 = `data:${result.headers['content-type']};base64,${base64}`;
                    return imageBase64;
                }
            }
            catch (e) {
                console.warn('error requesting miscellaneous document', accountId);
                return {
                    responseCode: GenericErrorResponseCode,
                    payload: e,
                };
            }
        }),
        getDocMetadata: (accountId, instructionId, id) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = GetTransferInstructionsDocumentMetadataUrl(accountId, instructionId, id);
            try {
                const result = yield api.authenticated().get(url, {}, RequestHeaders);
                return result;
            }
            catch (e) {
                console.warn('error requesting miscellaneous document metadata', { accountId, instructionId, id });
                return {
                    responseCode: GenericErrorResponseCode,
                    payload: e,
                };
            }
        }),
    };
}
export function cashieringProfile(api) {
    return {
        get: (accountId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { responseCode, payload } = yield api
                .authenticated()
                .get(`Cashiering/${accountId}/Profile`, {}, RequestHeaders);
            return { responseCode, payload };
        }),
    };
}
export function scheduledTransfers(api) {
    return {
        all: (accountId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { responseCode, payload } = yield api
                .authenticated()
                .get(`Cashiering/${accountId}/ScheduledTransfers`, {}, RequestHeaders);
            return { responseCode, payload };
        }),
        details: (accountId, scheduleId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { responseCode, payload } = yield api
                .authenticated()
                .get(`Cashiering/${accountId}/ScheduledTransfers/${scheduleId}`, {}, RequestHeaders);
            return { responseCode, payload };
        }),
        achDeposit: (accountId, data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().post(`Cashiering/${accountId}/ScheduledTransfers/Achs/Deposit`, data, RequestHeaders);
        }),
        achWithdrawal: (accountId, data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/ScheduledTransfers/Achs/Withdrawal`, data, RequestHeaders);
        }),
        wireWithdrawal: (accountId, data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/ScheduledTransfers/Wires/Withdrawal`, data, RequestHeaders);
        }),
        checkWithdrawal: (accountId, data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api
                .authenticated()
                .post(`Cashiering/${accountId}/ScheduledTransfers/Checks/Withdrawal`, data, RequestHeaders);
        }),
        update: (accountId, scheduleId, data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/ScheduledTransfers/${scheduleId}/Update`, data, RequestHeaders);
        }),
        cancel: (accountId, scheduleId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api
                .authenticated()
                .put(`Cashiering/${accountId}/ScheduledTransfers/${scheduleId}/Cancel`, {}, RequestHeaders);
        }),
    };
}
//# sourceMappingURL=cashiering.js.map